"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
import VendorStore from "../stores/vendor_store";
function clean(name) {
  return name.toLowerCase().replace(/[& -]/g, "");
}
export default {
  fetchUnmatched: function() {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/vendors/unmatched",
      type: "get",
      cache: false
    })).then(DataStoreService.responseHandler, _.identity);
  },
  search: function(name) {
    var vendorName = function(v) {
      return v.payment_name || v.name;
    };
    var sorted = _.sortBy(VendorStore.items, vendorName);
    return _.select(sorted, function(vendor) {
      return _.str.startsWith(clean(vendorName(vendor)), clean(name));
    }).slice(0, 20);
  }
};
